import { ReactNode } from 'react';
import { Stack } from '@mui/material';

type TabWrapperPrope = {
  index: number;
  value: number;
  children?: ReactNode;
};

const TabWrapper = ({ index, value, children }: TabWrapperPrope): JSX.Element => {
  const tabProps = {
    role: 'tabpanel',
    hidden: value !== index,
    id: `simple-tabpanel-${index}`,
    'aria-labelledby': `simple-tab-${index}`,
  };
  return (
    <div {...tabProps}>
      {value === index && (
        <Stack direction={'column'} spacing={2} sx={{ p: 3 }}>
          {children}
        </Stack>
      )}
    </div>
  );
};

export default TabWrapper;
